export const questionsReact = {
  English: [
    {
      question: "React is...",
      answers: [
        { answer: "Language", correct: false, id: 1 },
        { answer: "Library", correct: true, id: 2 },
        { answer: "Framework", correct: false, id: 3 },
        { answer: "API", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "What is a hook?",
      answers: [
        { answer: "Method", correct: false, id: 1 },
        { answer: "Object", correct: false, id: 2 },
        { answer: "Function", correct: true, id: 3 },
        { answer: "Class", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "What is the useState hook used for?",
      answers: [
        { answer: "To create references", correct: false, id: 1 },
        { answer: "To create context", correct: false, id: 2 },
        { answer: "To create state variables", correct: true, id: 3 },
        { answer: "To trigger side effects", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "What hook is used to trigger side effects?",
      answers: [
        { answer: "useEffect", correct: true, id: 1 },
        { answer: "useContext", correct: false, id: 2 },
        { answer: "useReducer", correct: false, id: 3 },
        { answer: "useCallback", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "What are props?",
      answers: [
        { answer: "Functions", correct: false, id: 1 },
        { answer: "States", correct: false, id: 2 },
        { answer: "Arguments", correct: true, id: 3 },
        { answer: "Methods", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
  Ukrainian: [
    {
      question: "React це...",
      answers: [
        { answer: "Мова", correct: false, id: 1 },
        { answer: "Бібліотека", correct: true, id: 2 },
        { answer: "Фреймворк", correct: false, id: 3 },
        { answer: "API", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Що таке хук?",
      answers: [
        { answer: "Метод", correct: false, id: 1 },
        { answer: "Об'єкт", correct: false, id: 2 },
        { answer: "Функція", correct: true, id: 3 },
        { answer: "Клас", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Для чого використовується хук useState?",
      answers: [
        { answer: "Для створення референцій", correct: false, id: 1 },
        { answer: "Для створення контексту", correct: false, id: 2 },
        { answer: "Для створення зміни стану", correct: true, id: 3 },
        { answer: "Для запуску побічних ефектів", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Який хук використовується для запуску побічних ефектів?",
      answers: [
        { answer: "useEffect", correct: true, id: 1 },
        { answer: "useContext", correct: false, id: 2 },
        { answer: "useReducer", correct: false, id: 3 },
        { answer: "useCallback", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Що таке пропси?",
      answers: [
        { answer: "Функції", correct: false, id: 1 },
        { answer: "Стан", correct: false, id: 2 },
        { answer: "Аргументи", correct: true, id: 3 },
        { answer: "Методи", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
  Polish: [
    {
      question: "Reakcja jest...",
      answers: [
        { answer: "Język", correct: false, id: 1 },
        { answer: "Biblioteka", correct: true, id: 2 },
        { answer: "Framework", correct: false, id: 3 },
        { answer: "API", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Co to jest hak?",
      answers: [
        { answer: "Metoda", correct: false, id: 1 },
        { answer: "Obiekt", correct: false, id: 2 },
        { answer: "Funkcjonować", correct: true, id: 3 },
        { answer: "Klasa", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Do czego służy hak useState?",
      answers: [
        { answer: "Aby utworzyć referencje", correct: false, id: 1 },
        { answer: "Aby stworzyć kontekst", correct: false, id: 2 },
        { answer: "Aby utworzyć zmienne stanu", correct: true, id: 3 },
        { answer: "Aby wywołać skutki uboczne", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Jaki hak służy do wywoływania skutków ubocznych?",
      answers: [
        { answer: "useEffect", correct: true, id: 1 },
        { answer: "useContext", correct: false, id: 2 },
        { answer: "useReducer", correct: false, id: 3 },
        { answer: "useCallback", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Co to są props?",
      answers: [
        { answer: "Funkcjonować", correct: false, id: 1 },
        { answer: "Stany", correct: false, id: 2 },
        { answer: "Argumenty", correct: true, id: 3 },
        { answer: "Metoda", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
  German: [
    {
      question: "React ist...",
      answers: [
        { answer: "Sprache", correct: false, id: 1 },
        { answer: "Bibliothek", correct: true, id: 2 },
        { answer: "Framework", correct: false, id: 3 },
        { answer: "API", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Was ist ein Haken?",
      answers: [
        { answer: "Methode", correct: false, id: 1 },
        { answer: "Objekt", correct: false, id: 2 },
        { answer: "Funktion", correct: true, id: 3 },
        { answer: "Klasse", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wofür wird der useState-Hook verwendet?",
      answers: [
        { answer: "Referenzen erstellen", correct: false, id: 1 },
        { answer: "Kontext schaffen", correct: false, id: 2 },
        { answer: "Um Zustandsvariablen zu erstellen", correct: true, id: 3 },
        { answer: "Nebenwirkungen auslösen", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Welcher Haken wird verwendet, um Nebenwirkungen auszulösen?",
      answers: [
        { answer: "useEffect", correct: true, id: 1 },
        { answer: "useContext", correct: false, id: 2 },
        { answer: "useReducer", correct: false, id: 3 },
        { answer: "useCallback", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Was sind Requisiten?",
      answers: [
        { answer: "Funktionen", correct: false, id: 1 },
        { answer: "Zustände", correct: false, id: 2 },
        { answer: "Argumente", correct: true, id: 3 },
        { answer: "Methoden", correct: false, id: 4 },
      ],
      score: 3,
    },
  ],
};
